import React from "react";
import TableBase from "./Base";
import { DateTimeFormat } from "../../helpers/utils";

const MaintenancesTable = ({
	scrollHeight,
	actionWidth,
	withAction,
	dataSource,
	...props
}) => {
	const COLUMNS = [
		{
			title: "Code",
			dataIndex: "code",
			width: 200,
		},
		{
			title: "Period From",
			dataIndex: "periodFrom",
			width: 150,
			render(record) {
				return DateTimeFormat(record);
			},
		},
		{
			title: "Period To",
			dataIndex: "periodTo",
			width: 150,
			render(record) {
				return DateTimeFormat(record);
			},
		},
		// {
		// 	title: "Enabled",
		// 	dataIndex: "enabled",
		// 	width: 150,
		// 	render(enabled) {
		// 		return enabled === true ? "Yes" : "No";
		// 	},
		// },
		{
			title: "Created At",
			dataIndex: "created_at",
			width: 150,
			ellipsis: true,
			render(record) {
				return DateTimeFormat(record);
			},
		},
		{
			title: "Updated At",
			dataIndex: "updated_at",
			width: 150,
			ellipsis: true,
			render(record) {
				return DateTimeFormat(record);
			},
		},
	];

	if (withAction) {
		COLUMNS.push({
			key: "action",
			width: actionWidth || 100,
			fixed: "right",
			render(record) {
				return withAction(record);
			},
		});
	}

	if (scrollHeight) {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991, y: scrollHeight }}
				{...props}
			/>
		);
	} else {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991 }}
				{...props}
			/>
		);
	}
};

export default MaintenancesTable;
